import { useTheme as _useTheme } from '@emotion/react';
import { Theme } from '@material-ui/core';
import { createEmotionTheme, IEMotionTheme } from './emotionTheme';
import { createMuiTheme } from './muiTheme';

export type FullTheme = Theme & IEMotionTheme;

const MUI_THEME = createMuiTheme();
const EMOTION_THEME = createEmotionTheme(MUI_THEME);

export const COMBINED_THEME: FullTheme = {
  ...MUI_THEME,
  ...EMOTION_THEME
};

export { EMOTION_THEME, MUI_THEME };

export const useTheme = _useTheme;
